import { useLocale } from "@jmc/core/src/hooks/useLocale/index";
import { PropTypes, Tabs } from "@jmc/solid-design-system/src/components/molecules/Tabs/Tabs";
import React from "react";
import { useTranslation } from "react-i18next";

export const JWMTabs = (props: PropTypes): JSX.Element => {
    const locale = useLocale();
    const { t } = useTranslation();

    return (
        <Tabs
            {...props}
            locale={locale}
            scrollLeftLiteral={t("Scroll left", { ns: "navigation" })}
            scrollRightLiteral={t("Scroll right", { ns: "navigation" })}
        />
    );
};
export default JWMTabs;
